import React from 'react';
import ReactDOM from 'react-dom';
import PopulationSpreadSim from './PopulationSpreadSim'
import { simulator, initializeSimulationState, statesList, linkRenderer, nodesRenderer } from './threeStatesSimulator'
import smallScenario from "./smallScenario";

const SmallScenarioSim = ({ portalId }) => {
  return ReactDOM.createPortal(
    <PopulationSpreadSim
      width={600}
      height={600}
      graph={smallScenario}
      simulator={simulator}
      statesList={statesList}
      initializeSimulationState={initializeSimulationState}
      linkRenderer={linkRenderer}
      nodesRenderer={nodesRenderer}
      framesPerDay={6}
      zoom={1.75}
    />,
    document.getElementById(portalId)
  );
};

export default SmallScenarioSim;